module.exports = __webpack_public_path__ + "img/1.ad36fabe.jpg";